import { generateUUID } from 'store/functions/geoJsonFunctions.js';
import { COST_VALIDATION_EMPTY_WARNING } from 'store/reducers/constants/constants.js';

export const travelCostUpdate = (state) => {
  const newState = {...state};
  state['data']['locations'].forEach((row, rowIdx) => {
    const newLoc = row['locationName']
    const newUuid = row['UUID']
    state['data']['locations'].forEach((col, colIdx) => {
      if (colIdx >= rowIdx) {
      const iterUuid = col['UUID'];
      const iterLoc = col['locationName'];
      let newCostRow = {  "UUID": generateUUID(),
                          "fromLocationName": iterLoc,
                          "toLocationName": newLoc, 
                          "duration": null,
                          "distance": null,
                          "cost": null,
                          "fromLocationId": iterUuid,
                          "toLocationId": newUuid,
                          "Valid": 'warning',
                          'validationMessage': COST_VALIDATION_EMPTY_WARNING
                        };
      if (state['tableSettings']['travel_costs']['isViewable']['vehicleType'] && state['data']['vehicle_types'].length > 0) {
        state.data['vehicle_types'].forEach((vehicle_type_row) => {
          const vehicle_type = vehicle_type_row['vehicleType']
          const vehicle_type_id = vehicle_type_row['UUID']
          newCostRow['vehicleType'] = vehicle_type
          newCostRow['vehicleTypeId'] = vehicle_type_id
          newCostRow['UUID'] = generateUUID()
          newState['data']['travel_costs'].push(JSON.parse(JSON.stringify(newCostRow)));
        })
      } 
      else {
        newState['data']['travel_costs'].push(newCostRow);
      }

      if (newLoc !== iterLoc) {
        newCostRow = {      "UUID": generateUUID(),
                            "fromLocationName": newLoc,
                            "toLocationName": iterLoc, 
                            "duration": null,
                            "distance": null,
                            "cost": null,
                            "fromLocationId": newUuid,
                            "toLocationId": iterUuid,
                            "Valid": 'warning',
                            'validationMessage': COST_VALIDATION_EMPTY_WARNING
                          };

      if (state['tableSettings']['travel_costs']['isViewable']['vehicleType'] && state['data']['vehicle_types'].length > 0) {
        state.data['vehicle_types'].forEach((vehicle_type_row) => {
          const vehicle_type = vehicle_type_row['vehicleType']
          const vehicle_type_id = vehicle_type_row['UUID']
          newCostRow['vehicleTypeId'] = vehicle_type_id
          newCostRow['vehicleType'] = vehicle_type
          newCostRow['UUID'] = generateUUID()
          newState['data']['travel_costs'].push(JSON.parse(JSON.stringify(newCostRow)));
        })
      } 
      else { 
        newState['data']['travel_costs'].push(newCostRow);
      }
      }
    }})
  })
  return newState;
}
